module.exports = __webpack_public_path__ + "img/lady_in_a_dress.35b71295.jpg";